import { ParentCompaniesAllPage } from '@/Components/Pages/Clients/ParentCompanies/ParentCompaniesAllPage';
import { ParentCompanyCreatePage } from '@/Components/Pages/Clients/ParentCompanies/ParentCompanyCreatePage';
import { ParentCompanyDetailPage } from '@/Components/Pages/Clients/ParentCompanies/ParentCompanyDetailPage';
import { ParentCompanyEditPage } from '@/Components/Pages/Clients/ParentCompanies/ParentCompanyEditPage';

import { RoutePage } from '../types';

export const ParentCompanies: RoutePage = {
    url: 'parent-companies',
    component: <ParentCompaniesAllPage />,
    permissions: {
        entity: 'ParentCompanies',
        admin: true,
        right: 'read',
    },
    sidebar: {
        name: 'Parent companies',
    },
    children: [
        {
            url: 'create',
            component: <ParentCompanyCreatePage />,
        },
        {
            url: ':id',
            component: <ParentCompanyDetailPage />,
            children: [
                {
                    url: 'edit',
                    component: <ParentCompanyEditPage />,
                },
            ],
        },
    ],
};
